import { createComponent } from '@/helpers/alpine';

const ProductAttributes = createComponent(() => ({
    isDrawerOpen: false,
    openGroups: [] as string[],
    groups: [] as string[],

    drawerOpen() {
        this.isDrawerOpen = true;
    },

    drawerClose() {
        this.isDrawerOpen = false;
        this.openGroups = [];

        this.$dispatch('drawer-close');
    },

    groupOpen(group: string) {
        if (this.isGroupOpen(group)) {
            return;
        }

        this.openGroups.push(group);
        this.$dispatch(`drawer-group-open-${group}`);
    },

    groupClose(group: string) {
        this.openGroups.slice(this.openGroups.indexOf(group), 1);
    },

    isGroupOpen(group: string) {
        return this.openGroups.includes(group);
    },
}));

export { ProductAttributes };
